import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function AddToCartModal({ product, onAddToCart, onClose }) {
  const [quantity, setQuantity] = useState(1);
  const amount = (quantity * product.price).toFixed(2);

  const handleAdd = () => {
  onAddToCart(product, quantity);  
  onClose();
};


  const handleQuantityChange = (e) => {
    const value = e.target.value;
    if (value === '' || (parseInt(value) > 0 && !isNaN(parseInt(value)))) {
      setQuantity(parseInt(value) || '');
    }
  };

  const handleBlur = () => {
    if (quantity === '') {
      setQuantity(1);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-30 p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 space-y-6">
        <div className="flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-900">Add Item</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={24} />
          </button>
        </div>

        <p className="text-center text-lg font-semibold text-gray-700">{product.name}</p>

        <div className="grid grid-cols-2 gap-4 items-end">
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Quantity</label>
            <input
              type="number"
              value={quantity}
              onChange={handleQuantityChange}
              onBlur={handleBlur}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 text-center text-lg"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Rate</label>
            <p className="text-lg p-3 font-semibold text-gray-800 text-center">₹{product.price.toFixed(2)}</p>
          </div>
        </div>

        <div className="border-t pt-4">
          <div className="flex justify-between items-center">
            <span className="text-lg font-medium text-gray-500">Amount</span>
            <span className="text-2xl font-bold text-teal-600">₹{amount}</span>
          </div>
        </div>

        <div className="flex gap-4">
          <button onClick={onClose} className="w-full py-3 px-4 rounded-lg bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300 transition-colors">
            Cancel
          </button>
          <button onClick={handleAdd} className="w-full py-3 px-4 rounded-lg bg-teal-600 text-white font-semibold hover:bg-teal-700 transition-colors shadow-md hover:shadow-lg">
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}
